import React, { useState } from "react";
import type { ReactNode } from "react";
import { C, FONT } from "../styles";

interface ChipButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
}

export default function ChipButton({ icon, label, onClick }: ChipButtonProps) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        border: "1px solid " + C.line,
        borderRadius: 10,
        padding: "8px 14px",
        fontSize: 13.5,
        fontWeight: 500,
        background: hover ? C.lineSoft : "#fff",
        cursor: "pointer",
        color: C.text,
        fontFamily: FONT,
      }}
    >
      <span style={{ color: C.tealInk, display: "inline-flex" }}>{icon}</span>
      {label}
    </button>
  );
}